export class BalanceRegistrationDetailEntity {
  createdAt?: string;
  updatedAt?: string;
  id?: string;
  name?: string;
  code?: string;
  description?: string;
  order?: number;
  type?: number;
  status?: number;
  note?: string;
  totalAmount?: string | number;
  transRef?: string | null;
  ownerId?: string;
  user?: BalanceRegistrationUserEntity;
  paymentMethod?: BalanceRegistrationPaymentMethodEntity;
  service?: BalanceRegistrationServiceEntity;
  transactionDetail?: BalanceRegistrationTransactionDetailEntity;
  product?: BalanceRegistrationProductEntity;
  paymentMethods?: BalanceRegistrationPaymentMethodEntity | Record<string, unknown>;
  platform?: string;

  constructor(data?: Partial<BalanceRegistrationDetailEntity>) {
    Object.assign(this, data);
  }
}

export class BalanceRegistrationUserEntity {
  createdAt?: string;
  updatedAt?: string;
  id?: string;
  userName?: string;
  name?: string;
  code?: string;
  email?: string | null;
  fullName?: string | null;
  birthDay?: string | null;
  phone?: string;
  description?: string | null;
  type?: number;
  status?: number;
  address?: string | null;
  confirmPayment?: number;
  taxCode?: string;
  isVerified?: boolean;
  note?: string | null;
  avatar?: string;
  partner?: unknown;
  parent?: unknown;

  constructor(data?: Partial<BalanceRegistrationUserEntity>) {
    Object.assign(this, data);
  }
}

export class BalanceRegistrationPaymentMethodEntity {
  createdAt?: string;
  updatedAt?: string;
  id?: string;
  name?: string;
  displayName?: string;
  code?: string;
  description?: string;
  cover?: string;
  url?: string;
  configuration?: Record<string, unknown>;
  items?: unknown;
  type?: number;
  status?: number;
  order?: number;
  supplier?: string;

  constructor(data?: Partial<BalanceRegistrationPaymentMethodEntity>) {
    Object.assign(this, data);
  }
}

export class BalanceRegistrationServiceEntity {
  name?: string;
  code?: string;
  iconUrl?: string;

  constructor(data?: Partial<BalanceRegistrationServiceEntity>) {
    Object.assign(this, data);
  }
}

export class BalanceRegistrationTransactionDetailEntity {
  createdAt?: string;
  updatedAt?: string;
  id?: string;
  name?: string | null;
  code?: string;
  description?: string | null;
  order?: number;
  type?: number;
  status?: number;
  note?: string | null;
  info?: {
    totalAmount?: number;
    discountRate?: number;
    discountAmount?: number;
    amount?: Array<{
      value?: number;
      name?: string;
    }>;
  };
  buyer?: BalanceRegistrationBuyerEntity;

  constructor(data?: Partial<BalanceRegistrationTransactionDetailEntity>) {
    Object.assign(this, data);
  }
}

export class BalanceRegistrationBuyerEntity {
  createdAt?: string;
  updatedAt?: string;
  id?: string;
  name?: string;
  email?: string;
  phone?: string;
  address?: string;
  type?: number;
  status?: number;
  extra?: string;

  constructor(data?: Partial<BalanceRegistrationBuyerEntity>) {
    Object.assign(this, data);
  }
}

export class BalanceRegistrationProductEntity {
  name?: string;
  code?: string;
  totalAmount?: string | number;
  type?: number;
  detail?: {
    createdAt?: string;
    updatedAt?: string;
    id?: string;
    name?: string;
    code?: string;
    amount?: string;
    status?: number;
    type?: number;
    description?: string | null;
    config?: unknown;
    order?: number;
    carrier?: string;
    totalAmount?: string;
    phoneNumber?: string;
    serial?: string;
    note?: string;
  };

  constructor(data?: Partial<BalanceRegistrationProductEntity>) {
    Object.assign(this, data);
  }
}
